import { render, staticRenderFns } from "./ReportePantalla.vue?vue&type=template&id=3c37b53b&"
import script from "./ReportePantalla.vue?vue&type=script&lang=ts&"
export * from "./ReportePantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports